import { render, staticRenderFns } from "./LandingHeader.html?vue&type=template&id=5a475bc4&"
import script from "./LandingHeader.ts?vue&type=script&lang=ts&"
export * from "./LandingHeader.ts?vue&type=script&lang=ts&"
import style0 from "./LandingHeader.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports